import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import History from '../../constants/history';

const NavigationProvider = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    History.navigate = navigate;
  }, [navigate]);

   useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default NavigationProvider;
